import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import _objectSpread from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/sdk_manage_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { popUp } from "@/mixins/index";
export default {
  mixins: [popUp],
  data: function data() {
    return {
      dialogFormVisible: false,
      reqLoading: false,
      formData: {
        id: "",
        reportListName: "report_params_list",
        reportData: [],
        report_name: ""
      },
      typeArrayList: [{
        label: "字典",
        value: "map"
      }],
      typeArrayValue: "map",
      rules: {
        report_name: [{
          required: true,
          message: "sdk名称",
          trigger: "blur"
        }]
      }
    };
  },
  created: function created() {},
  methods: {
    init: function init(data, isCopy) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var datas;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this.copyPrimitive();

                if (data) {
                  datas = JSON.parse(JSON.stringify(data));
                  datas.reportData = _this.$utils.convertToOriginalFormat(JSON.parse(datas.params));
                  _this.formData = _objectSpread({}, datas);

                  if (isCopy) {
                    _this.formData.id = "";
                  }
                }

                _this.formData.reportListName = "report_params_list";

                _this.copyData();

                _this.dialogFormVisible = true;

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    addArrayData: function addArrayData() {
      this.formData.reportData.push({
        reportKey: 'channel_name',
        reportVal: '',
        arrayData: []
      });
    },
    addArrayItemData: function addArrayItemData(index) {
      this.formData.reportData[index].arrayData.push({
        key: "",
        value: ""
      });
    },
    removeItemContent: function removeItemContent(index) {
      this.formData.reportData.splice(index, 1);
    },
    removeArrayItem: function removeArrayItem(index, idx) {
      this.formData.reportData[index].arrayData.splice(idx, 1);
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this2 = this;

      this.$refs.ruleForm.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var data, reqFn;
          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _this2.reqLoading = true;
                    _this2.copyPramsKeyData = _this2.$utils.convertFormat(_this2.formData.reportData);
                    data = {};
                    data.id = _this2.formData.id || "";
                    data.params = JSON.stringify(_this2.copyPramsKeyData);
                    data.report_name = _this2.formData.report_name;
                    console.log("data==", data);
                    reqFn = data.id ? 'reportConfigUpdate' : 'reportConfigAdd';

                    _this2.$api[reqFn](data).then(function (res) {
                      if (res.status == 200) {
                        _this2.$message({
                          message: '操作成功',
                          type: 'success'
                        });

                        _this2.dialogFormVisible = false;

                        _this2.$emit('change');
                      }
                    }).finally(function () {
                      _this2.reqLoading = false;
                    });
                  }

                case 1:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    }
  }
};